// extracted by mini-css-extract-plugin
export var dividerLine = "_48-0";
export var errorBackground = "_48-1";